import { useQuery } from '@tanstack/react-query'
import { getAsyncComponents } from '../../services/get'

type ComponentsData = Awaited<ReturnType<typeof getAsyncComponents>>;

export function useComponentsQuery() {
  return useQuery<ComponentsData>({
    queryKey: ['components'],
    queryFn: getAsyncComponents,
    staleTime: 5 * 60 * 1000,
  })
}
